import React from "react"
import "./css/Header.css"
import "./css/Products.css"
import TreeSeedling from "../assets/treeseedling1.jpg"
import MatureTree from "../assets/maturetree.jpeg"
import Flowers from "../assets/flowers.jpg"
import Vegetables from "../assets/vegetables.jfif"
import Spices from "../assets/spices.jpg"

const Products = () => {
  const products = [
    {
      name: "Tree Seedlings",
      category: "Forestry",
      description: "High-quality African indigenous tree seedlings for reforestation and conservation",
      fullText: "Our large and expansive Tree Nursery has a large variety of trees and for different uses including medicinal, fruit, fodder, building, firewood, shade, and ornamental. We focus on keeping stocks of African indigenous varieties which are difficult to find. We have well trained staff who take great care in ensuring seedlings are of good quality. Prices are kept low by using local resources. Our company has succeeded admirably in holding true to the vision of providing seedlings for reforestation to perpetuate our renewable resource. Our seedlings for export are of various sizes, ranging from 30cm in height up to customer requirements.",
      img: TreeSeedling,
      features: ["African Indigenous Varieties", "Export Quality", "30cm+ Height Range", "Medicinal & Ornamental Uses"],
      certifications: ["Quality Assured", "Local Resources", "Expert Staff"]
    },
    {
      name: "Mature Trees",
      category: "Landscaping",
      description: "Century-old mature trees including 100+ year old Baobab trees for instant landscape impact",
      fullText: [
        "As mature tree experts in East Africa, we produce high quality big trees (such as 100yrs old Adansonia Digitata (Baobab)) for sale to landscapers, commercial developers or private individuals seeking instant appeal and impact. We also offer professional big tree relocation and installation services for film industries, municipalities, building contractors and private residentials who need expert advice and assistance.",
        "If you are a Developer, Landscape Designer, Garden Designer, Horticulturalist contact us to transform your landscape instantly. Our Trees are shipped in Open Top Sea Containers to the Middle-East, Europe, Asia, Americas and other parts of the world. Legal documentation is available for all Trees. Talk to our qualified staff to discuss your projects requirements and seek a Quote for supply."
      ],
      img: MatureTree,
      features: ["Century-Old Trees", "Professional Installation", "Global Shipping", "Film Industry Services"],
      certifications: ["Legal Documentation", "Expert Installation", "Global Delivery"]
    },
    {
      name: "Flowers & Plants",
      category: "Horticulture",
      description: "Premium ornamental plants and export-quality flowers including specialized rose species",
      fullText: [
        "We stock a wide selection of plants ranging from the exotic to the more familiar tried and tested ornamental species with a selection of native local plants. Our range of plants include mature palms and trees grown or imported to order, acclimatized and then released to the market with our guarantee. We offer a similar service for shrubs, vines, ground covers and seasonal flowers.",
        "We supply quality flowers for export in a socially and environmentally responsible manner, geared towards satisfying customer needs while providing value to shareholders in dynamic and challenging atmosphere for employees. We specialize in rose species, and also other flower species."
      ],
      img: Flowers,
      features: ["Exotic & Native Species", "Rose Specialization", "Export Quality", "Mature Palms & Trees"],
      certifications: ["Quality Guarantee", "Socially Responsible", "Environmental Standards"]
    },
    {
      name: "Exotic Fruits & Vegetables",
      category: "Agriculture",
      description: "Fresh produce including green grams, french beans, avocados, and tropical fruits for export",
      fullText: [
        "We grow, harvest, process, package grains, tubers, fruits, vegetables for export. These includes green grams, french beans, white/yellow beans, fine beans, snow peas, oranges, tangerines, avocado, apple mangoes, macadamia, long chilies, bullet chilies, passion fruits, papaya, aubergine, sugar snaps & mange tout.",
        "All products are grown under Good Agricultural Practices and we are BRC, HACCP and Global Gap certified."
      ],
      img: Vegetables,
      features: ["Tropical Fruits", "Premium Beans", "Fresh Vegetables", "Export Processing"],
      certifications: ["BRC Certified", "HACCP Certified", "Global Gap Certified"]
    },
    {
      name: "Herbs & Spices",
      category: "Culinary",
      description: "Premium herbs and authentic Zanzibar spices including 27 varieties of traditional African blends",
      fullText: [
        "Jambo Tree is one of the leading growers and exporters of herbs i.e. Basil, Thyme, Rosemary, Mint, Lemon verbena, Melissa, Sage, Corriander, Dill, Chives, Oregano, Marjoram, French Tarragon. Our other products, Lovage, Birdseye Chilies, German Chamomile, Flat Parsley and Curled Parsley.",
        "Our Zanzibar Spices range includes 27 varieties of dried and grounded spices such as Tea Masala, Pilau Masala, Cloves, Cardamom and specific African masalas such as Ethiopian Berber spice and Githeri Masala."
      ],
      img: Spices,
      features: ["Leading Herb Exporter", "Zanzibar Spices", "27 Spice Varieties", "African Masalas"],
      certifications: ["Export Quality", "Traditional Processing", "Authentic Blends"]
    }
  ]

  return (
    <div className="products-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <div className="header-content">
            <h1 className="page-title">Our Products</h1>
            <p className="page-subtitle">
              Premium African indigenous products from seedlings to spices, sustainably grown and expertly processed
            </p>
          </div>
        </div>
      </section>

      {/* Products Overview */}
      <section className="products-overview-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">What We Offer</h2>
            <div className="title-underline"></div>
            <p className="section-description">
              From indigenous tree seedlings to century-old mature trees, from exotic flowers to premium spices, 
              we provide high-quality African products for local and international markets.
            </p>
          </div>
          
          <div className="products-stats">
            <div className="stat-item">
              <h3 className="stat-number">5</h3>
              <p className="stat-label">Product Categories</p>
            </div>
            <div className="stat-item">
              <h3 className="stat-number">200+</h3>
              <p className="stat-label">Tree Species</p>
            </div>
            <div className="stat-item">
              <h3 className="stat-number">27</h3>
              <p className="stat-label">Spice Varieties</p>
            </div>
            <div className="stat-item">
              <h3 className="stat-number">Global</h3>
              <p className="stat-label">Export Reach</p>
            </div>
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="products-grid-section">
        <div className="container">
          <div className="products-grid">
            {products.map((product, index) => (
              <div key={index} className="product-card">
                <div className="product-image-container">
                  <img src={product.img} alt={product.name} className="product-image" />
                  <div className="product-overlay">
                    <span className="product-category">{product.category}</span>
                  </div>
                </div>
                
                <div className="product-content">
                  <h3 className="product-name">{product.name}</h3>
                  <p className="product-description">{product.description}</p>
                  
                  <div className="product-features">
                    <h4>Key Features:</h4>
                    <ul>
                      {product.features.map((feature, featureIndex) => (
                        <li key={featureIndex}>{feature}</li>
                      ))}
                    </ul>
                  </div>
                  
                  <div className="product-certifications">
                    {product.certifications.map((cert, certIndex) => (
                      <span key={certIndex} className="certification-badge">{cert}</span>
                    ))}
                  </div>
                  
                  <button className="btn btn-primary product-btn" onClick={() => document.getElementById(`modal-${index}`).showModal()}>
                    Learn More
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Product Modals */}
      {products.map((product, index) => (
        <dialog key={index} id={`modal-${index}`} className="product-modal">
          <div className="modal-content">
            <div className="modal-header">
              <h3>{product.name}</h3>
              <button className="modal-close" onClick={() => document.getElementById(`modal-${index}`).close()}>×</button>
            </div>
            <div className="modal-body">
              <img src={product.img} alt={product.name} className="modal-image" />
              <div className="modal-text">
                {Array.isArray(product.fullText) ? (
                  product.fullText.map((paragraph, pIndex) => (
                    <p key={pIndex} className="modal-paragraph">{paragraph}</p>
                  ))
                ) : (
                  <p className="modal-paragraph">{product.fullText}</p>
                )}
              </div>
            </div>
            <div className="modal-footer">
              <a href="/work-with-us" className="btn btn-primary">Request Quote</a>
              <button className="btn btn-secondary" onClick={() => document.getElementById(`modal-${index}`).close()}>Close</button>
            </div>
          </div>
        </dialog>
      ))}

      {/* Quality Assurance */}
      <section className="quality-section">
        <div className="container">
          <div className="quality-content">
            <div className="quality-text">
              <h2 className="section-title">Quality Assurance</h2>
              <div className="title-underline"></div>
              <p className="quality-description">
                All our products are grown under Good Agricultural Practices and meet international quality standards. 
                We maintain strict quality control throughout our supply chain to ensure customer satisfaction.
              </p>
              
              <div className="quality-features">
                <div className="quality-item">
                  <h4>🌱 Sustainable Practices</h4>
                  <p>Environmentally responsible farming and harvesting methods</p>
                </div>
                <div className="quality-item">
                  <h4>🔬 Quality Control</h4>
                  <p>Rigorous testing and inspection at every stage</p>
                </div>
                <div className="quality-item">
                  <h4>📦 Expert Packaging</h4>
                  <p>Professional packaging for safe international shipping</p>
                </div>
                <div className="quality-item">
                  <h4>🌍 Global Standards</h4>
                  <p>BRC, HACCP, and Global Gap certified operations</p>
                </div>
              </div>
            </div>
            
            <div className="certifications-display">
              <h3>Our Certifications</h3>
              <div className="cert-badges">
                <div className="cert-badge">BRC</div>
                <div className="cert-badge">HACCP</div>
                <div className="cert-badge">Global Gap</div>
                <div className="cert-badge">ISO 14000</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="products-cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Place Your Order?</h2>
            <p>Contact our team to discuss your requirements and get a customized quote for our premium products.</p>
            <div className="cta-buttons">
              <a href="/work-with-us" className="btn btn-primary">Request Quote</a>
              <a href="/contact" className="btn btn-outline">Contact Sales</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Products